import { render, staticRenderFns } from "./ClientUpdateButton.vue?vue&type=template&id=27e892a0&"
import script from "./ClientUpdateButton.vue?vue&type=script&lang=js&"
export * from "./ClientUpdateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports